export default "__VITE_ASSET__DwGgOh4O__"